module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Widget Control Select */

(function(fox, undefined) {
    'use strict';

    fox.registerWidget('Control_Select', {
        configure: function(options) {
            this.registerOptions('', {
                autoRender: true,
                template: 'control_select',
                currentValuePlace: '.select-link',
                select: {
                    container: '.mc-select',

                    //object of attributes for <select> element
                    //{id, name, 'class', etc...}
                    attributes: null,

                    //array of objects like
                    //[{title:'title', value:'value', [selected: true, hidden: true]},{title:'title2', value:'value2']

                    options: null
                },

                //generate years options limited by array
                //[startYear, endYear]
                yearsLimit: false,

                //generate months select
                months: false,

                //genearate dates select
                days: false,

                'handleDom.change': {
                    target: '[name]',
                    event: 'change',
                    callback: '_change'
                },

                'hooks.onAddedToDom': 'change'
            });

            this.callParent('configure', arguments);
        },

        running: function () {
            this._prepareOptions();
            this.callParent('running', arguments);
        },

        createSelect: function () {
            var select = document.createElement('select');
            var container = this.getOption('select.container');
            //hack for translations
            if (this.getOption('months')) {
                this._prepareOptions();
            }
            
            fox.each(this.selectAttributes, function (value, attr) {
                select[attr] = value;
            }, this);

            fox.each(this.selectOptions, function (opts, i) {
                var option = document.createElement('option');

                option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
                option.value = opts.value;

                if (opts.selected && this.value === undefined) {
                    option.selected = true;
                    this.value = option.value;
                }

                if (this.value !== undefined && this.value === option.value) {
                    option.selected = true;
                }

                if (opts.hidden) {
                    option.style.display = 'none';
                }

                if(opts.disabled){
                    option.disabled = true;
                }

                if (opts.alterText) {
                    option.setAttribute('data-alter-text', opts.alterText);
                }

                select.appendChild(option);
            }, this);

            if (!select.name) {
                select.name = this.alias;
            }

            if (container) {
                this.dom1(container).appendChild(select);

                return;
            }

            this.fragment.appendChild(select);
        },

        rendering: function () {
            var addClass = this.getOption('addClass');
            
            if (addClass) {
                this.setTemplateOptions({addClass: addClass});
            }
            
            this.callParent('rendering', arguments);

            if (!this.selectOptions || !fox.count(this.selectOptions)) {
                //console.warn('No options defined');
                return;
            }

            this.hookWrapper('createSelect');
        },

        _change: function (el) {
            this.selectedOption = el.options[el.selectedIndex];

            this._setValue(this.selectedOption.value);
        },

        _setValue: function (value, skipEvent) {
            skipEvent = fox.isEmpty(skipEvent) ? false : skipEvent;

            if (value === this.value) {
                return;
            }

            this.value = value;
            this.hookWrapper('change');

            if (!skipEvent) {
                this.dispatchEvent('change', value);

                if (this.api) {
                    this.hookWrapper('send', {value: value});
                }
            }

            this.dispatchEvent('setValue', value);
        },

        _markOption: function (value) {
            fox.each(this.getSelectOptions(), function (option) {
                option.selected = false;

                if (option.value === value) {
                    option.selected = true;
                }
            }, this);
        },

        _prepareOptions: function (value) {
            var options = this.getOption('select.options');
            var yearsLimit = this.getOption('yearsLimit');
            var months = this.getOption('months');
            var days = this.getOption('days');

            this.selectAttributes = this.getOption('select.attributes');

            if (yearsLimit) {
                options = this._generateYears(yearsLimit);
            }

            if (months) {
                options = this._generateMonths();
            }

            if (days) {
                options = this._generateDays();
            }

            this.selectOptions = options;
        },

        change: function () {
            if (!this._indom) {
                return;
            }

            if ((this._indom === true) && !this.element.length) {
                console.warn('no element for select with name="' + this.alias + '"');

                return;
            }

            var place = this.dom1(this.getOption('currentValuePlace'));
            var selected = this.getSelectedOption();
            if (!selected) return;
            var txt = selected.innerText || selected.innerHTML;
            var alterText = selected.getAttribute('data-alter-text');

            if (alterText) {
                txt = alterText;
            }

            place.innerText = txt;

            fox.dom.removeClass('default', place.parentNode);

            if (selected.value < 0 || selected.value === '0') {
                fox.dom.addClass('default', place.parentNode);
            }
        },

        getSelectElement: function () {
            return this.dom1('[name="' + (this.getOption('select.attributes.name') || this.alias) + '"]');
        },

        getSelectOptions: function () {
            return fox.dom.select('option', this.getSelectElement());
        },

        getSelectedOption: function () {
            var el = false;

            fox.each(this.getSelectOptions(), function (option) {
                if (option.selected) {
                    el = option;
                }
            }, this);

            return el;
        },

        getValue: function () {
            return this.value;
        },

        setValue: function (value, skipEvent) {
            value = value.toString && value.toString() || value;
            this._markOption(value);
            this._setValue(value, skipEvent);
        },

        insertOptions: function (options, skipEvent) {
            var select = this.getSelectElement();

            if (!select) {
                console.warn('no select element');
                return;
            }

            fox.each(options, function (opts, i) {
                var option = document.createElement('option');

                option.innerText = fox.isFunction(opts.title) ? opts.title.call(null) : opts.title;
                option.value = opts.value;

                if (opts.selected) {
                    option.selected = true;
                    this.value = option.value;
                }

                if (opts.disabled) {
                    option.disabled = true;
                }

                select.appendChild(option);
            }, this);

            this._setValue(this.value, skipEvent);

        },

        rebuildSelect: function(options) {
            if (fox.isEmpty(options)) {
                return;
            }

            this.selectOptions = options;
            this.render();
        },

        _generateYears: function (arr) {
            var years = [];

            years.push({title: 'Year', value: '', selected: true, hidden: true});

            for (var i = arr[1]; i >= arr[0]; i--) {
                years.unshift({title: i, value: i});
            }

            return years;
        },

        _generateMonths: function () {
            var months = [];
            var monthNames = fox.utils.getMonthsArray();

            months.push({title: 'Month', value: '', selected: true, hidden: true});

            for (var i = 12; i > 0; i--) {
                months.unshift({title: monthNames[i - 1], value: (i < 10 ? '0' + i : i)});
            }

            return months;
        },

        _generateDays: function () {
            var days = [];

            days.push({title: 'Day', value: '', selected: true, hidden: true});

            for (var i = 31; i > 0; i--) {
                days.unshift({title: i, value: (i < 10 ? '0' + i : i)});
            }

            return days;
        },

        _toggleDisabling: function (state) {
            var select;

            if (this.isEmbedded()) {
                select = this.getSelectElement();
                select.disabled = state;

                return this.dispatchEvent(state && 'disabled' || 'enabled');
            }

            return this.wait('addedToDom').then(function () {
                return this._toggleDisabling(state);
            }.bind(this));
        },

        disable: function () {
            return this._toggleDisabling(true);
        },

        enable: function  () {
            return this._toggleDisabling(false);
        },

        reset: function () {
            this.value = undefined;
            this.render();
        }

    }, 'Widget');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/select.js
// module id = 303
// module chunks = 2